<template>
  <v-snackbar
    v-model="show"
    :color="color"
    :top="true"
    :right="true"
  >
    {{ $store.getters["snackbar_store/getText"] }}

    <template v-slot:action="{ attrs }">
      <v-btn
        text
        v-bind="attrs"
        @click="$store.commit('snackbar_store/hideSnackbar')"
      >
        Закрыть
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: "Snackbar",

  computed: {
    show: {
      get: function () {
        return this.$store.getters["snackbar_store/getShow"]
      },
      set: function (newValue) {
        this.$store.commit("snackbar_store/setShow", newValue)
      }
    },
    color () {
      return this.$store.getters["snackbar_store/getColor"]
    }
  }
}
</script>

<style scoped></style>
